import React from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import RadioButton from 'design-system/RadioButton';
import { formatPlural } from 'utils';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import { isWeb } from '../../../../constants';
const KeyboardTagsRow = ({ item, onPress, isSelected, type }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<TouchableHighlight hoverOnLight onCard activeOpacity={1} onPress={onPress} underlayColor={colors.background.underlay}>
      <View style={styles.container}>
        <RadioButton isChecked={isSelected} type={type}/>
        <Spacer w={16}/>
        <View style={styles.flex}>
          <Text Text-16 numberOfLines={1}>
            #{item.label}
          </Text>
          <Text TextThin-14 Secondary numberOfLines={1}>
            {item.nOfTransactions} {formatPlural('transaction', 'transactions', item.nOfTransactions || 0)}
          </Text>
        </View>
      </View>
    </TouchableHighlight>);
};
const ICON_SIZE = 44;
const styleSet = createStyleSheets((colors) => ({
    container: {
        paddingVertical: rem(16),
        paddingHorizontal: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
        ...(isWeb && {
            paddingHorizontal: 8,
        }),
    },
    icon: {
        width: rem(ICON_SIZE),
        height: rem(ICON_SIZE),
        borderRadius: rem(ICON_SIZE),
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.background.dark,
    },
    flex: {
        flex: 1,
    },
}));
export default KeyboardTagsRow;
